import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import Button from '@mui/material/Button';
import { useCallback } from 'react';
import { toggleIsHiDpiAllowed } from '../../../../redux/actions/sessionActions';
import { useAppDispatch, useAppSelector } from '../../../../redux/store';
import { getBooleanString } from '../../../../utils/utils';
import { DebugItemContainer } from './debugItemContainer';
export const HiDpiDebugItemContainer = () => {
    const dispatch = useAppDispatch();
    const isHiDpiAllowed = useAppSelector((state) => state.session.isHiDpiAllowed);
    const isPokerRoom = useAppSelector((state) => state.scene.roomSceneType === 'poker');
    const onClick = useCallback(() => {
        dispatch(toggleIsHiDpiAllowed());
    }, [dispatch]);
    const isHiDpiAllowedString = getBooleanString(isHiDpiAllowed);
    // Don't allow changing the Hi-DPI setting in poker rooms because the change may cause a crash.
    // You can toggle it in the lobby.
    const contents = isPokerRoom ? (isHiDpiAllowedString) : (_jsx(Button, { onClick: onClick, variant: 'outlined', size: 'small', color: 'inherit', children: isHiDpiAllowedString }));
    return _jsx(DebugItemContainer, { title: 'Is Hi-DPI Allowed', value: contents });
};
